import React from 'react';
import type { SwiperOptions } from 'swiper/types';

import { CoopSwiperBreakpoints } from '../../../utility/coopSwiperBreakpoints';
import { useBreakpointsSidebar } from '../../ecommerce/hooks/useBreakpoints';
import { useSwiperOverflowClasses } from './useSwiperOverflowClasses';

const useBuyableRecipesBreakpoints = () => {
    const { breakpoints, cellsInRow } = useBreakpointsSidebar(
        CoopSwiperBreakpoints.AREA_NEW_RECIPE_LIST,
    );

    const { mainSwiperClasses, spaceBetween } = useSwiperOverflowClasses({
        spaceBetween: 10,
    });

    const swiperOptions = React.useMemo(
        () =>
            ({
                spaceBetween,
                breakpoints,
            }) as SwiperOptions,
        [breakpoints, spaceBetween],
    );

    return { swiperOptions, mainSwiperClasses, cellsInRow };
};

export default useBuyableRecipesBreakpoints;
